import { Route, Routes } from 'react-router-dom'
import { AuthorizedAppsAccessLayout } from 'pages/settings/pages/personal/pages/authorizedApps/layout/AuthorizedAppsAccessLayout'
import { AuthorizedAppsViewProvider } from 'pages/settings/pages/developer/pages/authorizedApps/context/authorizedAppsViewContext'
import { AuthorizedAppsPage } from 'pages/settings/pages/developer/pages/authorizedApps/ui/authorizedAppsPage'

export const AuthorizedAppsRouter = () => {
  return (
    <Routes>
      <Route element={<AuthorizedAppsAccessLayout />}>
        <Route
          path='/'
          element={
            <AuthorizedAppsViewProvider>
              <AuthorizedAppsPage />
            </AuthorizedAppsViewProvider>
          }
        />
      </Route>
    </Routes>
  )
}
